import {Typography} from "@material-ui/core";
import React, {FC} from "react";
import {useTranslate} from "@tolgee/react";
import {OrderStatusMap} from "tools/order/getOrderStatus";

type Props = {
  statusMap: OrderStatusMap;
};

const OrderStatusLabel: FC<Props> = ({statusMap}) => {
  const {t} = useTranslate();
  const {label, translationKey, color} = statusMap;

  return (
    <Typography
      variant="body2"
      style={{
        color,
        fontWeight: 500,
      }}
    >
      {translationKey ? t({key: translationKey, defaultValue: label}) : label}
    </Typography>
  );
};

export default OrderStatusLabel;
